// @flow
/** @jsx isolateComponent */

import { Colors } from '@zapier/theme';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

const Styles = labelStyles(__filename, {
  color: Colors.mystique,
});

type Props = {
  children: React.Node,
  href: string,
};

const StyledLink = (props: Props) => (
  // $FlowFixMe should this be color? `link` doesn't exist
  <a css={Styles.link} href={props.href}>
    {props.children}
  </a>
);

export default StyledLink;
